module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor-graph_LV-4541c93ee299648293440619d4215339.svg";